// The package owns its strings so the hosted site (next-intl) and the widget
// (i18next) show the same words. ICU syntax, translated with use-intl's
// framework-free translator.
import { createTranslator } from "use-intl/core";
import de from "./messages/de.json";
import en from "./messages/en.json";
import fr from "./messages/fr.json";

import { toBookingLocale } from "../locale";

export { BOOKING_LOCALES, toBookingLocale, type BookingLocale } from "../locale";

const MESSAGES = { en, fr, de };

export type BookingMessages = typeof en;

export function createBookingTranslator(locale: string) {
  const l = toBookingLocale(locale);
  // English is the reference shape; fr and de carry the same keys.
  return createTranslator({ locale: l, messages: MESSAGES[l] as BookingMessages });
}

export type BookingTranslator = ReturnType<typeof createBookingTranslator>;
